var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlankAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 105,
    viewBox: "0 0 90 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4369 30.3786C60.4369 38.8718 53.5516 45.7573 45.0583 45.7573C36.5647 45.7573 29.6796 38.872 29.6796 30.3786C29.6796 21.885 36.5649 15 45.0583 15C53.5515 15 60.4369 21.8852 60.4369 30.3786Z",
    fill: "#FF8F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0583 47.3884C28.3981 47.3884 15 60.9029 15 77.4466C15 93.9903 75 93.9903 75 77.4466C75 60.7864 61.7184 47.3884 45.0583 47.3884Z",
    fill: "#FF8F88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankAvatar);
export default __webpack_public_path__ + "static/media/BlankAvatar.8709e4df033c2bb2fa4f9bfbb10c46b8.svg";
export { ForwardRef as ReactComponent };